module.exports = __webpack_public_path__ + "img/image50.517bd9ba.png";